<template>
    <div style="display: flex; justify-content: space-between; flex-direction: column; height: 75vh">
        <div class="external-activity--card" :style="`border-radius: ${activity.card_border_radius}px; box-shadow: none;`">
            <div style="margin-top: 100px">
                <div class="text-center">{{ defaultCartLanguage.select_language }}</div>
                <div class="external-activity--card-content">
                    <a v-for="language in languages" class="single--language" :class="attemptedLanguage.code === language.code ? 'active' : ''" href="#" @click.prevent="setAttemptedLanguage(language)">{{ language.label }}</a>
                </div>
            </div>
        </div>
        <button class="btn" :style="attemptedLanguage.code !== null ? '': 'background-color: #EDEDED!important; color: #908c8c!important'" style="width: 90%; margin-left: 20px" @click.prevent="localSelectLanguage()">Confirm</button>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex'
    export default {
        props: ['activity', 'languages', 'selectLanguage'],
        computed: {
            ...mapGetters(['defaultCartLanguage'])
        },
        data () {
            return {
                attemptedLanguage: { code: null},
            }
        },
        methods: {
            setAttemptedLanguage(language) {
                this.attemptedLanguage = language
            },

            localSelectLanguage() {
                if( this.attemptedLanguage.code !== null ) {
                    this.selectLanguage(this.attemptedLanguage)
                    this.attemptedLanguage = { code: null}
                }
            }
        },
    }
</script>
